import Vue from 'vue';

export const newProjectService = {
  async createProject(projectData) {
    return Vue.axios.post('/projects/create', { ...projectData }).then(response => response.data);
  }
};
